const HEX_COLOR_PATTERN = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;

export const isValidHexColor = (value) => HEX_COLOR_PATTERN.test(String(value || "").trim());

export const normalizeHexColor = (value) => {
  const trimmed = String(value || "").trim();
  if (!trimmed) {
    return "";
  }

  let hex = trimmed.startsWith("#") ? trimmed : `#${trimmed}`;

  if (/^#[0-9A-Fa-f]{3}$/.test(hex)) {
    hex = `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`;
  }

  if (!HEX_COLOR_PATTERN.test(hex)) {
    return "";
  }

  return hex.toUpperCase();
};

export const hexColorForPicker = (value, fallback = "#808080") => {
  const normalized = normalizeHexColor(value);
  return normalized || fallback;
};

export const resolveColorSwatchBackground = (colorRecord, labelResolver) => {
  const hexCode = normalizeHexColor(colorRecord?.hexCode);
  if (hexCode) {
    return hexCode;
  }

  const label = labelResolver ? labelResolver(colorRecord) : colorRecord?.colorName || colorRecord?.name || "";
  if (!label) {
    return "#E5E7EB";
  }

  if (typeof document !== "undefined") {
    const probe = document.createElement("div");
    probe.style.color = label.toLowerCase();
    const resolved = probe.style.color;
    if (resolved && resolved !== "inherit") {
      return label.toLowerCase();
    }
  }

  let hash = 0;
  const normalized = String(label).toLowerCase();
  for (let index = 0; index < normalized.length; index += 1) {
    hash = (hash * 31 + normalized.charCodeAt(index)) >>> 0;
  }

  return `hsl(${hash % 360} 52% 46%)`;
};
